// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*================================================================================
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Version: 2.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
================================================================================

NOTE:
------
PLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.
WE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */
.master-view-batch-table.shrink-table .rdt_TableHead,
.master-view-batch-table.shrink-table .rdt_TableBody {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;iGAAA;AAYA;;EAEE,WAAA;AAAF","sourcesContent":["/*================================================================================\r\n\tItem Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template\r\n\tVersion: 2.0\r\n\tAuthor: PIXINVENT\r\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\r\n================================================================================\r\n\r\nNOTE:\r\n------\r\nPLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.\r\nWE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */\r\n\r\n.master-view-batch-table.shrink-table .rdt_TableHead,\r\n.master-view-batch-table.shrink-table .rdt_TableBody {\r\n  width: 100%\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
